import { PayloadAction } from 'typesafe-actions';
import { DeviceManagementContextActionTypes, DeviceManagementState } from './types';

const DeviceManagementReducer = (
  state: DeviceManagementState,
  action: PayloadAction<DeviceManagementContextActionTypes, any>,
): DeviceManagementState => {
  switch (action.type) {
    case DeviceManagementContextActionTypes.SetSelectedDevice:
      return {
        ...state,
        selectedDevice: action.payload,
      };

    case DeviceManagementContextActionTypes.ResetSelectedDevice:
      return {
        ...state,
        selectedDevice: null,
      };

    case DeviceManagementContextActionTypes.SetCurrentPage:
      return {
        ...state,
        currentPage: action.payload,
      };

    case DeviceManagementContextActionTypes.SetPaginationSettings:
      return {
        ...state,
        paginationSettings: {
          ...state.paginationSettings,
          pageOffset: action.payload.pageOffset,
        },
      };

    case DeviceManagementContextActionTypes.SetPaginationResult:
      return {
        ...state,
        paginationResult: {
          ...state.paginationResult,
          totalResults: action.payload.totalResults,
          totalPages: action.payload.totalPages,
        },
      };

    default: {
      return state;
    }
  }
};

export { DeviceManagementReducer };
